module.exports = __webpack_public_path__ + "static/media/education-object-0-2-1.4e68f012.svg";